import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Heart, Users, ChevronRight, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { RelationshipAssessmentForm } from '@/components/relational/RelationshipAssessmentForm';

interface RelationalPulsePromptProps {
  onComplete?: () => void;
}

export function RelationalPulsePrompt({ onComplete }: RelationalPulsePromptProps) {
  const [showAssessment, setShowAssessment] = useState(false);
  const navigate = useNavigate();

  const handleQuickPulse = () => {
    navigate('/sanctuary?tab=relational');
  };

  const handleFullAssessment = () => {
    setShowAssessment(true);
  };

  const handleAssessmentComplete = () => {
    setShowAssessment(false);
    onComplete?.();
  };

  return (
    <>
      <Card className="bg-gradient-to-br from-accent/10 via-accent/5 to-background border-accent/20">
        <CardHeader className="pb-2">
          <div className="flex items-center gap-2">
            <div className="p-2 rounded-lg bg-accent/10">
              <Heart className="w-5 h-5 text-accent" />
            </div>
            <CardTitle className="text-base">Relational Pulse Check</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-muted-foreground">
            How are your relationships feeling today? A quick check-in can reveal insights about your connection patterns.
          </p>
          
          <div className="flex gap-2">
            <Button 
              variant="outline" 
              size="sm" 
              className="flex-1"
              onClick={handleQuickPulse}
            >
              <Sparkles className="w-4 h-4 mr-1" />
              Quick Pulse
            </Button>
            <Button 
              size="sm" 
              className="flex-1 bg-secondary hover:bg-secondary/90 text-secondary-foreground"
              onClick={handleFullAssessment}
            >
              <Users className="w-4 h-4 mr-1" />
              Full Assessment
            </Button>
          </div>
        </CardContent>
      </Card>

      <Dialog open={showAssessment} onOpenChange={setShowAssessment}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto p-0">
          <RelationshipAssessmentForm
            relationshipType="romantic"
            onComplete={handleAssessmentComplete}
            onCancel={() => setShowAssessment(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
